import useClusterConfig from "hooks/useClusterConfig";
const INVESTIGATION_MESSAGES_STREAM_CONFIG = "org.graylog.plugins.securityapp.migrations.InvestigationMessagesStreamConfig";
const useInvestigationsMessagesConfig = () => useClusterConfig(INVESTIGATION_MESSAGES_STREAM_CONFIG);
export default useInvestigationsMessagesConfig;
